// State ======================
import globalActions from '../api/GlobalActions.js'
import globalMutations from '../api/GlobalMutations.js'
import globalGetters from '../api/GlobalGetters.js'
import { sanitizeUsagePayload, sanitizeUsageUpdatePayload } from '../api/UsagePayload.js'
import { isUsageRunningAt } from '../api/usageTime.js'

export const state = () => ({
  type: 'usages',
  canEdit: false,
  canView: false,
  effectedByYear: true,
  refreshRelationsOnWrite: false,
  yearFields: [],
  relations: [
    {
      name: 'farmunit',
      label: 'Farmunit',
      compactLabel: 'Farmunit',
      translate: 'farmunit',
      value: 'farmunits',
      storename: 'farmunits',
      multiple: false,
      yearFields: [],
      export: {
        single: true,
        list: true
      },
      filterOnAttributes: true
    },
    {
      name: 'user',
      label: 'User',
      compactLabel: 'User',
      translate: 'user',
      value: 'users',
      storename: 'users',
      multiple: false,
      yearFields: [],
      export: {
        single: true,
        list: true
      },
      filterOnAttributes: false
    },
    {
      name: 'ditch',
      label: 'Ditch',
      compactLabel: 'Ditch',
      translate: 'ditch',
      value: 'ditches',
      storename: 'ditches',
      multiple: false,
      yearFields: [],
      export: {
        single: true,
        list: true
      },
      filterOnAttributes: true
    },
    {
      name: 'diversionPoint',
      label: 'T/O',
      compactLabel: 'T/O',
      translate: 'diversionPoint',
      value: 'diversionPoints',
      storename: 'diversionPoints',
      multiple: false,
      yearFields: [],
      export: {
        single: true,
        list: true
      },
      filterOnAttributes: true
    },
    {
      name: 'division',
      label: 'Division',
      compactLabel: 'Division',
      translate: 'division',
      value: 'divisions',
      storename: 'divisions',
      multiple: false,
      yearFields: [],
      export: {
        single: true,
        list: true
      },
      filterOnAttributes: true
    },
    {
      name: 'producer',
      label: 'Producer',
      compactLabel: 'Producer',
      translate: 'producer',
      value: 'contacts',
      storename: 'contacts',
      yearFields: [],
      export: {
        single: true,
        list: true
      },
      multiple: false,
      filterOnAttributes: true
    }
  ],
  all: {},
  reference: {
    /* for showing paginated resources ... needs a bit more work. */
  },
  active: false,
  startDate: null,
  page: 1,
  pageCount: 0,
  pagination: {
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    itemsPerPage: 150,
    sort: true,
    sortBy: 'on_date',
    page: 1,
    sortDesc: []
  },
  total: 0,
  print: false,
  export: false,
  print_path: '',
  bound: {
    // hours: "",
    // run_date: "",
    // flow: "",
    // ditch: "",
    // diversionPoint: "",
    // farmunit: "",
    // producer: "",
    // usageArray: [],
  },
  filter: {
    // hours: "",
    // flow: "",
    // ditch: "",
    // diversionPoint: "",
    // farmunit: "",
  },
  stub: {
    ditch: []
  },
  notifications: {},
  include: 'farmunit,ditch,user,diversionPoint',
  headers: {}
})

// Mutations ==================

export const mutations = {
  ...globalMutations,
  setStartDate: (state, date) => {
    state.startDate = date
  }
}

// Actions ====================

export const actions = {
  ...globalActions,
  create (context, payload) {
    return globalActions.create.call(this, context, sanitizeUsagePayload(payload))
  },
  update (context, { id, payload, ...options }) {
    const existing = context.getters.find(id)

    return globalActions.update.call(this, context, {
      id,
      payload: sanitizeUsageUpdatePayload(payload, existing),
      ...options
    })
  }
}

// Getters ====================

export const getters = {
  ...globalGetters,
  // dpId -> raw usage records that could plausibly be running (open, or turned
  // off within the last day). Computed once per usages-store change instead of
  // every consumer scanning the whole store. Records are raw (relations as ids).
  openUsagesByDiversionPoint (state) {
    const cutoff = new Date(Date.now() - 24 * 60 * 60 * 1000)
    const cutoffDate = `${cutoff.getFullYear()}-${String(cutoff.getMonth() + 1).padStart(2, '0')}-${String(cutoff.getDate()).padStart(2, '0')}`
    const map = {}
    Object.values(state.all).forEach((usage) => {
      if (usage.off_date && usage.off_date < cutoffDate) {
        return
      }
      const dp = usage.diversionPoint && typeof usage.diversionPoint === 'object'
        ? usage.diversionPoint.id
        : usage.diversionPoint
      if (dp === null || dp === undefined || dp === '') {
        return
      }
      const key = String(dp)
      if (!map[key]) {
        map[key] = []
      }
      map[key].push(usage)
    })
    return map
  },
  runningUsagesFor: (state, allGetters) => (diversionPoint, at = new Date()) => {
    const id = diversionPoint && typeof diversionPoint === 'object'
      ? diversionPoint.id
      : diversionPoint
    if (id === null || id === undefined || id === '') {
      return []
    }
    return (allGetters.openUsagesByDiversionPoint[String(id)] || [])
      .filter(usage => isUsageRunningAt(usage, at))
  }
}
